import {FormVariant, SectionSideBySideFieldsFragment} from '@common/hygraph-schema';
import {SideBySideVerifySection} from './SideBySideVerify.section';
import {SideBySideRedeemSection} from './SideBySideRedeem.section';

export const SideBySideSection = (props: SectionSideBySideFieldsFragment) => {
	switch (props.formVariant) {
		case FormVariant.RedeemCode: {
			return <SideBySideRedeemSection {...props} />;
		}
		case FormVariant.VerifyCode: {
			return <SideBySideVerifySection {...props} />;
		}
		default: {
			// return default side by side with no form
			throw new Error('Not yet supported');
		}
	}
};
